import Icon from "../Icon";
import CircularProgress from "material-ui-old/CircularProgress";
import { Input, Select } from "antd";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { denormalize } from "normalizr";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import heatmapDrawboxImg from "../../assets/heatmap-drawbox.png";
import heatmapKeyBarImg from "../../assets/heatmap-key-bar.png";
import * as colors from "../../helpers/constants/colors";
import { capitalizeAllFirstLetters } from "../../helpers/string";
import { shouldLoadOnMount } from "../../modules/asyncHttpAction";
import { B2B_DICT, B2B_VALUE_DICT } from "../../modules/drivers";
import { pageResultsSchema, pageSchema } from "../../schemas";
import styles from "../../styles/components/LikesDislikes.css";
import Datatable from "../Datatable";
import GeneralErrorScreen from "../GeneralErrorScreen";
import HeatMap, { HeatmapPointRadius } from "../HeatMap";
import SearchText, { search } from "../SearchText";
import ToggleButton from "../ToggleButton";
import QuoteCell, { endash } from "./QuoteCell";

const { Option, OptGroup } = Select;

export const HEATMAP_CONTAINER_ELEMENT_ID = "likesAndDislikesHeatmapContainer";

const INCOME_AUDIENCE_ID = 1;
const GENDER_AUDIENCE_ID = 2;
const AGE_AUDIENCE_ID = 3;
const EDUCATION_AUDIENCE_ID = 4;
const B2C_CATEGORY_ID = 1;
const B2B_CATEGORY_ID = 2;

const DEFAULT_B2B_FILTERS = {
    b2bAge: "All ages",
    b2bRevenue: "All revenues",
    b2bRole: "All roles",
    b2bSize: "All sizes"
};

const B2B_KEY_TO_LABEL = {
    b2bAge: "Business Age",
    b2bRevenue: "Revenue",
    b2bRole: "Role",
    b2bSize: "Company Size"
};

const B2B_FILTERS = {
    b2bAge: [
        {
            value: "All ages",
            label: "All ages",
            sortOrder: 0
        },
        {
            value: "Less than 1 year",
            label: "Less than 1 year",
            sortOrder: 1
        },
        {
            value: "1-2 years",
            label: `1${endash}2 years`,
            sortOrder: 2
        },
        {
            value: "3-5 years",
            label: `3${endash}5 years`,
            isChecked: true,
            sortOrder: 3
        },
        {
            value: "6-9 years",
            label: `6${endash}9 years`,
            isChecked: true,
            sortOrder: 4
        },
        {
            value: "10+ years",
            label: `10+ years`,
            isChecked: true,
            sortOrder: 5
        }
    ],
    b2bRevenue: [
        {
            value: "All revenues",
            label: "All revenues",
            sortOrder: 0
        },
        {
            value: "<$500k",
            label: "<$500k",
            sortOrder: 2
        },
        {
            value: "$500k - <$1M",
            label: `$500k ${endash} <$1M`,
            sortOrder: 4
        },
        {
            value: "$1M - <$2M",
            label: `$1M ${endash} <$2M`,
            sortOrder: 5
        },
        {
            value: "$2M - <$5M",
            label: `$2M ${endash} <$5M`,
            sortOrder: 6
        },
        {
            value: "$5M - <$10M",
            label: `$5M ${endash} <$10M`,
            sortOrder: 7
        },
        {
            value: "$10M - <$25M",
            label: `$10M ${endash} <$25M`,
            sortOrder: 8
        },
        {
            value: "$25M - <$50M",
            label: `$25M ${endash} <$50M`,
            sortOrder: 9
        },
        {
            value: "$50M - <$100M",
            label: `$50M ${endash} <$100M`,
            sortOrder: 10
        },
        {
            value: "$100M - <$500M",
            label: `$100M ${endash} <$500M`,
            sortOrder: 11
        },
        {
            value: "$500M - <$1B",
            label: `$500M ${endash} <$1B`,
            sortOrder: 12
        },
        {
            value: "$1B - <$10B",
            label: `$1B ${endash} <$10B`,
            sortOrder: 13
        },
        {
            value: "$10B+",
            label: `$10B+`,
            sortOrder: 14
        }
    ],
    b2bRole: [
        {
            value: "All roles",
            label: "All roles",
            sortOrder: 0
        },
        {
            value: "Entry Level",
            label: "Entry Level",
            sortOrder: 1
        },
        {
            value: "Home Based Business Owner",
            label: "Home Based Business Owner",
            sortOrder: 2
        },
        {
            value: "Front Line Management",
            label: "Front Line Management",
            sortOrder: 3
        },
        {
            value: "Experienced: Professional or Non-Management",
            label: "Experienced: Professional or Non-Management",
            sortOrder: 4
        },
        {
            value: "Middle Management",
            label: "Middle Management",
            sortOrder: 5
        },
        {
            value: "Senior Management",
            label: "Senior Management",
            sortOrder: 6
        },
        { value: "Business Owner", label: "Business Owner", sortOrder: 7 },
        { value: "Owner / Partner", label: "Owner / Partner", sortOrder: 8 },

        { value: "Other", label: "Other", sortOrder: 9 }
    ],
    b2bSize: [
        {
            value: "All sizes",
            label: "All sizes",
            sortOrder: 0
        },
        { value: "1", label: "1", sortOrder: 1 },
        { value: "2-10", label: `2${endash}10`, sortOrder: 3 },
        {
            value: "10-49",
            label: `10${endash}49`,
            sortOrder: 4
        },
        {
            value: "50-99",
            label: `50${endash}99`,
            sortOrder: 5
        },
        {
            value: "100-249",
            label: `100${endash}249`,
            sortOrder: 6
        },
        {
            value: "250-499",
            label: `250${endash}499`,
            sortOrder: 7
        },
        {
            value: "500-999",
            label: `500${endash}999`,
            sortOrder: 8
        },
        {
            value: "1,000-2,499",
            label: `1,000${endash}2,499`,
            sortOrder: 9
        },
        {
            value: "2,500-4,999",
            label: `2,500${endash}4,999`,
            isChecked: true,
            sortOrder: 10
        },
        {
            value: "5,000-9,999",
            label: `5,000${endash}9,999`,
            sortOrder: 11
        },
        {
            value: "10,000-24,999",
            label: `10,000${endash}24,999`,
            sortOrder: 12
        }
    ]
};

function findSegmentByAudienceId(point, audienceId) {
    return point.segmentIds.find(s => {
        return s.audienceId === audienceId;
    });
}

function findSegmentLabelForPoint(point, audienceId) {
    const segment = findSegmentByAudienceId(point, audienceId);
    return findSegmentLabel(segment);
}

function findSegmentLabel(segment) {
    if (!segment) {
        return "-";
    }
    return segment.label;
}

function makeCellRendererForAudienceSegment(audienceId) {
    return point => findSegmentLabelForPoint(point, audienceId);
}

export function pointInRegion(point, region, pageImage) {
    const { x, y } = point;
    const scaleX = x => (x * pageImage.width) / 100;
    const scaleY = y => (y * pageImage.height) / 100;
    const minX = scaleX(region.x);
    const minY = scaleY(region.y);
    const maxX = minX + scaleX(region.width);
    const maxY = minY + scaleY(region.height);
    return x < maxX && x > minX && y > minY && y < maxY;
}

/*
 Configuration of the datatable columns. Check the Datatable component for more details
 about implementation and props
 */

const DATATABLE_COLUMNS = [
    {
        renderHeaderCell: () => null,
        renderBodyCell: point => <Icon icon="star-o" />,
        cellWidthPercentage: 2
    },
    {
        renderHeaderCell: () => <h5>Quote</h5>,
        renderBodyCell: point => {
            const isB2B =
                point.DEM_B2B_Age ||
                point.DEM_B2B_Revenue ||
                point.DEM_B2B_Role ||
                point.DEM_B2B_Size;

            return (
                <QuoteCell
                    quoteContent={
                        <SearchText
                            text={point.quote}
                            matchIndices={point.matchIndices}
                        />
                    }
                    segmentIds={
                        isB2B
                            ? [
                                  B2B_DICT[point.DEM_B2B_Age],
                                  B2B_DICT[point.DEM_B2B_Revenue],
                                  B2B_DICT[point.DEM_B2B_Role],
                                  B2B_DICT[point.DEM_B2B_Size]
                              ]
                            : point.segmentIds
                                  .filter(s => !isNil(s))
                                  .map(({ id }) => id)
                    }
                />
            );
        }
    },
    {
        renderHeaderCell: () => <h5>Type</h5>,
        renderBodyCell: point => {
            const { clusterType } = point;
            let color = colors.success;
            let icon = "thumbs-o-up";
            if (clusterType === "LeastAppeal") {
                color = colors.error;
                icon = "thumbs-o-down";
            }
            return React.createElement(icon, {
                style: { color, textAlign: "center" }
            });
        },
        cellWidthPercentage: 2
    },
    {
        renderHeaderCell: () => <h5>Gender</h5>,
        renderBodyCell: makeCellRendererForAudienceSegment(GENDER_AUDIENCE_ID),
        cellWidthPercentage: 2
    },
    {
        renderHeaderCell: () => <h5>Age</h5>,
        renderBodyCell: makeCellRendererForAudienceSegment(AGE_AUDIENCE_ID),
        cellWidthPercentage: 2
    },
    {
        renderHeaderCell: () => <h5>Income</h5>,
        renderBodyCell: makeCellRendererForAudienceSegment(INCOME_AUDIENCE_ID),
        cellWidthPercentage: 3
    },
    {
        renderHeaderCell: () => <h5>Education</h5>,
        renderBodyCell: makeCellRendererForAudienceSegment(
            EDUCATION_AUDIENCE_ID
        ),
        cellWidthPercentage: 7
    }
];

class LikesAndDislikes extends React.Component {
    static FILTERABLE_AUDIENCE_IDS = [
        GENDER_AUDIENCE_ID,
        AGE_AUDIENCE_ID,
        INCOME_AUDIENCE_ID,
        EDUCATION_AUDIENCE_ID
    ];

    static CLUSTER_TABS = [
        {
            label: "Likes",
            clusterName: "MostAppeal"
        },
        {
            label: "Dislikes",
            clusterName: "LeastAppeal"
        }
    ];

    static initialState = {
        searchQuery: "",
        selectedClusterIndex: 0,
        segmentFilters: {},
        b2bFilters: {
            ...DEFAULT_B2B_FILTERS
        },
        showHeatmap: true,

        selectedDataId: null,
        columns: [false, true, false, false, false],
        tags: true,

        selectedRegion: null
    };

    constructor(props) {
        super(props);
        this.state = {
            ...LikesAndDislikes.initialState
        };

        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.toggleHeatmapVisibility = this.toggleHeatmapVisibility.bind(this);

        this.handleSelectQuote = this.handleSelectQuote.bind(this);
        this.handleSelectRegionChange = this.handleSelectRegionChange.bind(
            this
        );
    }

    componentWillMount() {
        if (
            !this.props.pageResults ||
            shouldLoadOnMount(this.props.pageResultRequest)
        ) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.pageResults && prevProps.pageId !== this.props.pageId) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.page.id !== nextProps.page.id) {
            this.setState(LikesAndDislikes.initialState);
        }
    }

    toggleHeatmapVisibility() {
        this.setState(state => {
            return {
                showHeatmap: !state.showHeatmap
            };
        });
    }

    handleQueryChange(e) {
        const val = e.target.value;
        this.setState({
            query: val.trim()
        });
    }

    handleAudienceChange(audienceId, value) {
        this.setState(state => {
            return {
                segmentFilters: {
                    ...state.segmentFilters,
                    [audienceId]: value
                }
            };
        });
    }

    handleB2bFilterChange(b2bKey, value) {
        if (isNil(value)) {
            value = DEFAULT_B2B_FILTERS[b2bKey];
        }

        this.setState(state => {
            return {
                b2bFilters: {
                    ...state.b2bFilters,
                    [b2bKey]: value
                }
            };
        });
    }

    handleClusterTypeToggle(index) {
        this.setState({
            selectedClusterIndex: index
        });
    }

    handleSelectQuote(rowIndex, point) {
        if (this.contentElement) {
            const contentNode = ReactDOM.findDOMNode(this.contentElement);
            const rect = contentNode.getBoundingClientRect();
            // magic number 54 = the height of the header
            // magic number 20 = visually appealing whitespace
            const top = window.scrollY + rect.top - 54 - 20;
            if (top > window.scrollY) {
                window.scrollTo(window.scrollX, top);
            }
        }
        this.setState(state => {
            const currentId = state.selectedDataId;
            // if the quote is already selected, we unselect it. otherwise we select it
            return {
                selectedDataId: currentId === point.id ? null : point.id
            };
        });
    }

    handleSelectRegionChange(region) {
        this.setState({ selectedRegion: region, selectedDataId: null });
    }

    renderTitle() {
        return (
            <div className={styles.chapterHeader}>
                <h2 className={styles.chapterTitle}>Audience Reactions</h2>
                <p className={styles.chapterSubtitle}>
                    This reaction map shows what your target audience likes and
                    dislikes about each page and why.
                </p>
            </div>
        );
    }

    renderHeatmapTitle() {
        const toggleHeatmapText = this.state.showHeatmap ? "hide" : "show";
        return (
            <div className={styles.heatmapCellTitleBar}>
                <div
                    className={`${styles.heatmapCellTitle} ${
                        styles.contentCellTitle
                    }`}
                >
                    <h3>Reaction Map</h3>
                    <p onClick={this.toggleHeatmapVisibility}>
                        ({toggleHeatmapText})
                    </p>
                </div>
                <div>
                    <a
                        className={styles.helpText}
                        data-tip="help-tooltip"
                        data-for="help"
                    >
                        <p>
                            help <Icon icon={"info-circle"} />
                        </p>
                    </a>
                </div>
                {this.renderHelpContent()}
            </div>
        );
    }

    renderTabBar() {
        const firstStyle = {
            borderRadius: "5px 0px 0px 5px",
            borderRight: "none"
        };
        const defaultStyle = {
            borderRadius: "none",
            borderRight: "none",
            borderLeft: "none"
        };
        const lastStyle = {
            borderRadius: "0px 5px 5px 0px",
            borderLeft: "none"
        };
        return (
            <div className={styles.likeDislikeTabBar}>
                {LikesAndDislikes.CLUSTER_TABS.map(
                    (likeDislikeTab, index, array) => {
                        const style =
                            (index === 0 && firstStyle) ||
                            (index === array.length - 1 && lastStyle) ||
                            defaultStyle;
                        return (
                            <ToggleButton
                                key={`quotes-like-dislike-${index}`}
                                style={style}
                                label={likeDislikeTab.label}
                                isSelected={
                                    this.state.selectedClusterIndex === index
                                }
                                onClick={() =>
                                    this.handleClusterTypeToggle(index)
                                }
                            />
                        );
                    }
                )}
            </div>
        );
    }

    renderHeatmapBar() {
        return (
            <div className={styles.resultsDatatableFilterBar}>
                {this.renderTabBar()}
                <div className={styles.audienceFilters}>
                    {!this.props.showB2bFilters &&
                        LikesAndDislikes.FILTERABLE_AUDIENCE_IDS.map(id =>
                            this.props.audiences.find(
                                audience => audience.id === id
                            )
                        )
                            .filter(Boolean)
                            .map(audience =>
                                this.renderAudienceFilterDropdown(
                                    audience,
                                    this.state.segmentFilters[audience.id]
                                )
                            )}
                    {this.props.showB2bFilters &&
                        Object.keys(B2B_FILTERS).map(b2bKey =>
                            this.renderB2bFilterDropdown(
                                b2bKey,
                                this.state.b2bFilters[b2bKey]
                            )
                        )}
                </div>
            </div>
        );
    }

    renderFilterBar() {
        return (
            <div className={styles.resultsDatatableFilterBar}>
                <Input.Search
                    className={styles.quoteSearch}
                    defaultValue={this.state.query}
                    placeholder="Search quotes..."
                    onChange={this.handleQueryChange}
                />
            </div>
        );
    }

    renderAudienceFilterDropdown(audience, segmentFilter) {
        const audienceLabel = capitalizeAllFirstLetters(audience.label);
        const segments = audience.segments
            .map(seg => seg.segment)
            .sort((seg1, seg2) => seg1.sortOrder - seg2.sortOrder);

        const audienceLabelPlural = `All ${audienceLabel}s`;

        return (
            <Select
                className={styles.audienceFilter}
                allowClear
                onChange={value =>
                    this.handleAudienceChange(audience.id, value)
                }
                key={`audience-select-${audience.id}`}
                value={!isNil(segmentFilter) ? segmentFilter : "0"}
                dropdownMatchSelectWidth={false}
            >
                <OptGroup label={audienceLabel}>
                    <Option value="0">{audienceLabelPlural}</Option>
                    {segments.map(seg => (
                        <Option
                            key={`audience-segment(${seg.id})`}
                            value={seg.id.toString()}
                        >
                            {capitalizeAllFirstLetters(seg.label)}
                        </Option>
                    ))}
                </OptGroup>
            </Select>
        );
    }

    renderB2bFilterDropdown(b2bKey, b2bFilter) {
        return (
            <Select
                className={styles.audienceFilter}
                allowClear
                onChange={value => this.handleB2bFilterChange(b2bKey, value)}
                key={`b2b-select-${b2bKey}`}
                value={
                    !isNil(b2bFilter) ? b2bFilter : DEFAULT_B2B_FILTERS[b2bKey]
                }
                dropdownMatchSelectWidth={false}
            >
                <OptGroup label={B2B_KEY_TO_LABEL[b2bKey]}>
                    {B2B_FILTERS[b2bKey].map(filter => (
                        <Option
                            key={`${b2bKey}-${filter.label}`}
                            value={filter.value}
                        >
                            {capitalizeAllFirstLetters(filter.label)}
                        </Option>
                    ))}
                </OptGroup>
            </Select>
        );
    }

    renderHeatmap(image, points, highlightedPoint, radius) {
        return (
            <HeatMap
                className={styles.heatmapWrapper}
                image={image}
                data={points}
                highlightedPoint={highlightedPoint}
                showOverlay={this.state.showHeatmap}
                selectedRegion={this.state.selectedRegion}
                onSelectRegionChange={this.handleSelectRegionChange}
                radius={radius}
            />
        );
    }

    renderHelpContent() {
        return (
            <ReactTooltip
                id="help"
                class={styles.helpTooltip}
                place="bottom"
                type="light"
                effect="solid"
                border={true}
                delayShow={200}
                offset={{ left: 225, top: -30 }}
            >
                <div className={styles.helpContent}>
                    <div className={styles.helpContentItem}>
                        <h4>
                            {
                                LikesAndDislikes.CLUSTER_TABS[
                                    this.state.selectedClusterIndex
                                ].label
                            }
                        </h4>
                        <div className={styles.heatmapKeyBarContainer}>
                            <img src={heatmapKeyBarImg} />
                            <div className={styles.helpSubtitle}>
                                <p>Least</p>
                                <p>Most</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.helpContentItem}>
                        <h4>Select Area</h4>
                        <div className={styles.helpSelectAreaContent}>
                            <p>Click and drag to select an area on the map</p>
                            <div className={styles.heatmapDrawboxContainer}>
                                <img src={heatmapDrawboxImg} />
                            </div>
                        </div>
                    </div>
                </div>
            </ReactTooltip>
        );
    }

    render() {
        const { pageResults, page } = this.props;

        if (!pageResults) {
            return (
                <div className={styles.chapter}>
                    {this.renderTitle()}
                    <div>
                        <CircularProgress />
                    </div>
                </div>
            );
        }

        const pageImage = page.image.files.heatmap;
        if (!pageImage) {
            const error = new Error(
                `No heatmap image associated with page ${page.id}`
            );
            return (
                <GeneralErrorScreen
                    error={error}
                    redirectLink="/"
                    redirectText="Back to your Dashboard"
                />
            );
        }

        const numRespondents = pageResults.points.reduce(
            (acc, point) => acc.add(point.responseId),
            new Set()
        ).size;

        const {
            selectedClusterIndex,
            query,
            segmentFilters,
            b2bFilters
        } = this.state;
        let radius;
        if (numRespondents >= 500) {
            radius = HeatmapPointRadius.Small;
        } else if (numRespondents <= 75) {
            radius = HeatmapPointRadius.Large;
        } else {
            radius = HeatmapPointRadius.Normal;
        }

        const selectedCluster =
            LikesAndDislikes.CLUSTER_TABS[this.state.selectedClusterIndex];
        let filteredPoints = pageResults.points.filter(
            p =>
                p.clusterType === selectedCluster.clusterName && !isNil(p.quote)
        );

        let hasSegmentFilter = false;
        if (!this.props.showB2bFilters) {
            Object.values(segmentFilters).forEach(segmentId => {
                if (isNil(segmentId) || segmentId === "0") {
                    return;
                }
                hasSegmentFilter = true;
                filteredPoints = filteredPoints.filter(p =>
                    p.segmentIds.some(
                        segment =>
                            segment && segment.id === parseInt(segmentId, 10)
                    )
                );
            });
        }

        let hasB2bFilter = false;
        if (this.props.showB2bFilters) {
            hasB2bFilter = Object.values(b2bFilters).some(
                filter => !!filter && !filter.includes("All")
            );
            filteredPoints = filteredPoints.filter(
                ({
                    DEM_B2B_Age: age,
                    DEM_B2B_Revenue: revenue,
                    DEM_B2B_Role: role,
                    DEM_B2B_Size: size
                }) => {
                    const responses = [age, revenue, role, size].filter(
                        response => !!response
                    ); // only look for defined values
                    return responses.every(response =>
                        Object.values(b2bFilters).some(filter =>
                            B2B_VALUE_DICT[filter].options.includes(response)
                        )
                    );
                }
            );
        }

        if (!isEmpty(query)) {
            filteredPoints = search(["quote"], filteredPoints, query);
        }

        // filter by selected region, if region is selected
        const region = this.state.selectedRegion;
        let displayableQuotes = region
            ? filteredPoints.filter(point =>
                  pointInRegion(point, region, pageImage)
              )
            : filteredPoints;

        // If there is a query, keep fuse's relevance sorting otherwise sort by quote score
        if (isEmpty(query)) {
            displayableQuotes = displayableQuotes.sort(
                (point1, point2) => point2.quoteScore - point1.quoteScore
            );
        }
        const heatmapPoints = filteredPoints.filter(
            p => p.x !== null && p.y !== null
        );

        const highlightedPoint = isNil(this.state.selectedDataId)
            ? null
            : heatmapPoints.find(p => p.id === this.state.selectedDataId);

        const nonQuoteWidth = this.state.columns
            .filter((_, index) => index !== 1)
            .filter(Boolean)
            .reduce((acc, c) => acc + c.cellWidthPercentage, 0);
        const columns = this.state.columns
            .map(
                (display, index) =>
                    display &&
                    Datatable.createColumn({
                        ...DATATABLE_COLUMNS[index],
                        cellWidthPercentage:
                            index === 1
                                ? 100 - nonQuoteWidth
                                : DATATABLE_COLUMNS[index].cellWidthPercentage
                    })
            )
            .filter(Boolean);

        const hasQuotes = displayableQuotes.length > 0;
        const showQuoteCount =
            region || !isEmpty(query) || hasSegmentFilter || hasB2bFilter;

        return (
            <div className={styles.chapter}>
                {this.renderTitle()}

                <div
                    className={`${styles.toolbar} ${styles.resultsContentRow}`}
                    ref={elt => (this.contentElement = elt)}
                >
                    <div
                        className={`${styles.filtersWrapper} ${
                            styles.resultsContentRowCell
                        }`}
                    >
                        {this.renderHeatmapBar()}
                    </div>
                    <div
                        className={`${styles.quotesTableCell} ${
                            styles.resultsContentRowCell
                        }`}
                    >
                        {this.renderFilterBar()}
                    </div>
                </div>
                <div className={`${styles.resultsContentRow}`}>
                    <div
                        id={HEATMAP_CONTAINER_ELEMENT_ID}
                        className={`${styles.heatmapCell} ${
                            styles.resultsContentRowCell
                        }`}
                    >
                        {this.renderHeatmapTitle()}
                        {this.renderHeatmap(
                            pageImage,
                            heatmapPoints,
                            highlightedPoint,
                            radius
                        )}
                    </div>
                    <div
                        className={`${styles.quotesTableCell} ${
                            styles.resultsContentRowCell
                        }`}
                    >
                        <div
                            className={`${styles.quoteCellTitle} ${
                                styles.contentCellTitle
                            }`}
                        >
                            <h3>Quotes</h3>
                            {showQuoteCount && (
                                <p>Showing {displayableQuotes.length} quotes</p>
                            )}
                        </div>
                        <Datatable
                            className={
                                LikesAndDislikes.CLUSTER_TABS[
                                    selectedClusterIndex
                                ].clusterName
                            }
                            scroll={{ height: "75vh" }}
                            onRowClick={this.handleSelectQuote}
                            columns={columns}
                            data={displayableQuotes}
                            columnClassName={styles.rowCell}
                            showHeaders={false}
                            rowClassName={(rowIndex, rowDatum) =>
                                (this.state.selectedDataId === rowDatum.id &&
                                    "selected-point") ||
                                ""
                            }
                        >
                            <div
                                className={`${styles.quotesTableCaption} ${
                                    hasQuotes
                                        ? styles.hasQuotes
                                        : styles.noQuotes
                                }`}
                            >
                                {!hasQuotes && (
                                    <h4>
                                        Sorry! There are no quotes to display.
                                    </h4>
                                )}
                                <p>
                                    Quotes are displayed based on their
                                    relevance and quality. We’ve hidden quotes
                                    that aren’t useful, but kept their points on
                                    the reaction map.
                                </p>
                            </div>
                        </Datatable>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const { wevo, pageId } = props;
    const showB2bFilters =
        wevo.audienceCategory && wevo.audienceCategory.id === B2B_CATEGORY_ID;

    const page = denormalize(pageId, pageSchema, state.api) || null;
    const pageResults =
        denormalize(pageId, pageResultsSchema, state.api) || null;

    return {
        page,
        audiences: wevo ? wevo.audiences : null,
        pageResults: pageResults,
        showB2bFilters
    };
}

export default connect(mapStateToProps)(LikesAndDislikes);
export { LikesAndDislikes as PureComponent };



// WEBPACK FOOTER //
// ./src/components/Results/LikesAndDislikes.js